<template>
    <base-view class="material-base-report-view">
        <veui-tabs :active="$route.path">
            <veui-tab v-for="tab in tabs"
                :key="tab.label"
                :label="tab.label"
                :to="tab.to">
                <router-view v-if="$route.path === tab.to"/>
            </veui-tab>
        </veui-tabs>
    </base-view>
</template>

<script>
import BaseView from '@baidu/ve-ria/views/BaseView';
import createView from '@baidu/ve-ria/views/createView';
import Model from './SummaryModel';
import {Tabs, Tab} from 'veui';

export default createView(BaseView, Model, {
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab
    },
    data() {
        return {
            tabs: Object.freeze([
                {label: '卡片', to: '/stats/material/base/card/list'},
                {label: '中间页', to: '/stats/material/base/frame/list'},
                {label: '组件', to: '/stats/material/base/component/list'}
            ])
        };
    }
});
</script>

<style lang="less">
.material-base-report-view {
    .veui-tabs-menu {
        margin-bottom: 40px;
    }
}
</style>
